import { storyblokEditable } from "gatsby-source-storyblok"

import ArticleTable from "@components/V2/Lab/ArticleTable"
import { Color } from "@constants/V2/color"
import React from "react"

const MIN_COLUMNS = 2
const MAX_COLUMNS = 3

const toCellValues = (cells?: Storyblok.TableCell[]) =>
  (cells ?? []).map((cell) => cell?.value ?? "")

const hasContent = (cells: string[]) =>
  cells.some((cell) => cell.trim().length > 0)

const padToLength = (cells: string[], length: number) => [
  ...cells,
  ...Array.from({ length: length - cells.length }, () => ""),
]

const ArticleTableStoryblok = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ArticleTable>) => {
  const headers = toCellValues(blok.data?.thead).slice(0, MAX_COLUMNS)

  const rows = (blok.data?.tbody ?? [])
    .map((row) => toCellValues(row?.body).slice(0, headers.length))
    .filter(hasContent)
    .map((cells) => padToLength(cells, headers.length))

  if (headers.length < MIN_COLUMNS || !hasContent(headers) || rows.length === 0)
    return null

  return (
    <ArticleTable
      headers={headers}
      rows={rows}
      highlightColor={blok.backgroundColor || Color.Blue}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default ArticleTableStoryblok
